module.exports = __webpack_public_path__ + "img/subtitle2.0262538f.png";